import { Teacher } from './types';
import { mockSchools } from './mockSchools';

export const mockTeachers: Teacher[] = [
  {
    id: 'teacher-001',
    username: 'jsmith',
    firstName: 'John',
    lastName: 'Smith',
    email: 'jsmith@swunmath.edu',
    role: 'Teacher',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    classes: ['class-001', 'class-002'],
    school: mockSchools[0],
    grade: '5'
  },
  {
    id: 'teacher-002',
    username: 'awilliams',
    firstName: 'Amanda',
    lastName: 'Williams',
    email: 'awilliams@swunmath.edu',
    role: 'Teacher',
    avatar: 'https://randomuser.me/api/portraits/women/65.jpg',
    classes: ['class-003'],
    school: mockSchools[0],
    grade: '3'
  },
  {
    id: 'teacher-003',
    username: 'rjohnson',
    firstName: 'Robert',
    lastName: 'Johnson',
    email: 'rjohnson@swunmath.edu',
    role: 'Teacher',
    avatar: 'https://randomuser.me/api/portraits/men/43.jpg',
    classes: ['class-004'],
    school: mockSchools[1],
    grade: '4'
  },
  {
    id: 'teacher-004',
    username: 'mjackson',
    firstName: 'Maria',
    lastName: 'Jackson',
    email: 'mjackson@swunmath.edu',
    role: 'Teacher',
    avatar: 'https://randomuser.me/api/portraits/women/28.jpg',
    classes: ['class-005'],
    school: mockSchools[1],
    grade: '2'
  },
  {
    id: 'teacher-005',
    username: 'tlee',
    firstName: 'Thomas',
    lastName: 'Lee',
    email: 'tlee@swunmath.edu',
    role: 'Teacher',
    avatar: 'https://randomuser.me/api/portraits/men/55.jpg',
    classes: [],
    school: mockSchools[2],
    grade: '4'
  },
  {
    id: 'teacher-006',
    username: 'sgarcia',
    firstName: 'Sophia',
    lastName: 'Garcia',
    email: 'sgarcia@swunmath.edu',
    role: 'Teacher',
    avatar: 'https://randomuser.me/api/portraits/women/33.jpg',
    classes: [],
    school: mockSchools[2],
    grade: '1'
  },
  {
    id: 'teacher-007',
    username: 'wbrown',
    firstName: 'William',
    lastName: 'Brown',
    email: 'wbrown@swunmath.edu',
    role: 'Teacher',
    avatar: 'https://randomuser.me/api/portraits/men/67.jpg',
    classes: [],
    school: mockSchools[0],
    grade: '6'
  },
  {
    id: 'teacher-008',
    username: 'emiller',
    firstName: 'Emma',
    lastName: 'Miller',
    email: 'emiller@swunmath.edu',
    role: 'Teacher',
    avatar: 'https://randomuser.me/api/portraits/women/12.jpg',
    classes: [],
    school: mockSchools[1],
    grade: '3'
  },
  {
    id: 'teacher-009',
    username: 'dclark',
    firstName: 'David',
    lastName: 'Clark',
    email: 'dclark@swunmath.edu',
    role: 'Teacher',
    avatar: 'https://randomuser.me/api/portraits/men/21.jpg',
    classes: [],
    school: mockSchools[2],
    grade: '5'
  },
  {
    id: 'teacher-010',
    username: 'orodriguez',
    firstName: 'Olivia',
    lastName: 'Rodriguez',
    email: 'orodriguez@swunmath.edu',
    role: 'Teacher',
    avatar: 'https://randomuser.me/api/portraits/women/45.jpg',
    classes: [],
    school: mockSchools[0],
    grade: 'K'
  }
]; 